/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Tokenaccesscount2Inputs */

const de__field_tokenaccesscount2 = /** @type {(inputs: _Field_Tokenaccesscount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Anzahl der Token-Anmeldungen für Schüler:innen`)
};

/**

* @param {_Field_Tokenaccesscount2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_tokenaccesscount2 = /** @type {((inputs?: _Field_Tokenaccesscount2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Tokenaccesscount2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_tokenaccesscount2(inputs)
});
export { _field_tokenaccesscount2 as "_field_tokenAccessCount" }